import Box from '@mui/material/Box'
import styled from '@emotion/styled'

const HelfSplitGrid = styled(Box)`
  ${({ theme }) => `
    display: grid;
    grid-auto-rows: auto;

    grid-template-columns: repeat(2, 1fr);

    grid-column-gap: ${theme.spacing(2)};
    ${theme.breakpoints.up('lg')} {
      grid-column-gap: ${theme.spacing(6)};
    }
  `}
`

export default HelfSplitGrid
